/**
 * Single source of truth for "are we on the manager surface?". The manager
 * route subtree (`/brands/[slug]/manager` + nested sub-routes like the
 * observatory) drives the sidebar→top-navbar swap in `SidebarLayout` and the
 * "Open Manager" → "Back to platform" entry flip in the account dropdown. Keep
 * the two readers in lockstep by always going through this helper.
 */
export function isManagerRoute(pathname: string | null | undefined): boolean {
    return /^\/brands\/[^/]+\/manager(?:\/|$)/.test(pathname ?? '')
}
